import styled from 'styled-components';

export const TableBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0 0 0;
  width: 100%;
`;
